import React, { useMemo, useState } from 'react';
import { MOCK_LABELERS, MOCK_QUEUES, QUEUE_ORDER } from '../../mocks';

export const LabelerManagementPage: React.FC = () => {
  // Get unique queue names in canonical order
  const queueNames = useMemo(() => {
    const seen = new Map<string, string>();
    for (const q of MOCK_QUEUES) {
      if (!seen.has(q.queueName)) {
        seen.set(q.queueName, q.displayName);
      }
    }
    return [...seen.entries()]
      .sort((a, b) => (QUEUE_ORDER[a[0]] ?? 99) - (QUEUE_ORDER[b[0]] ?? 99))
      .map(([name, display]) => ({ name, display }));
  }, []);

  const [assignments, setAssignments] = useState<Record<string, Set<string>>>(() =>
    Object.fromEntries(MOCK_LABELERS.map((l) => [l.id, new Set(l.assignedQueues)]))
  );

  const toggleAssignment = (labelerId: string, queueName: string) => {
    setAssignments((prev) => {
      const current = new Set(prev[labelerId]);
      if (current.has(queueName)) {
        current.delete(queueName);
      } else {
        current.add(queueName);
      }
      return { ...prev, [labelerId]: current };
    });
  };

  return (
    <div className="page-content">
      <div style={{ marginBottom: 20 }}>
        <h2 style={{ fontSize: 18, fontWeight: 700 }}>Labeler Management</h2>
        <p style={{ fontSize: 13, color: 'var(--text-secondary)', marginTop: 4 }}>
          Assign labelers to queues using the matrix below.
        </p>
      </div>

      <div style={{ overflowX: 'auto' }}>
        <table className="admin-table">
          <thead>
            <tr>
              <th>Labeler</th>
              <th>Role</th>
              {queueNames.map((q) => (
                <th key={q.name} style={{ textAlign: 'center' }}>
                  {q.display}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {MOCK_LABELERS.map((labeler) => (
              <tr key={labeler.id}>
                <td>
                  <div style={{ fontWeight: 600 }}>{labeler.name}</div>
                  <div
                    style={{
                      fontFamily: 'var(--font-mono)',
                      fontSize: 11,
                      color: 'var(--text-tertiary)',
                    }}
                  >
                    {labeler.email}
                  </div>
                </td>
                <td style={{ color: 'var(--text-secondary)' }}>{labeler.role}</td>
                {queueNames.map((q) => (
                  <td key={q.name} style={{ textAlign: 'center' }}>
                    <input
                      type="checkbox"
                      className="forge-checkbox"
                      checked={assignments[labeler.id]?.has(q.name) || false}
                      onChange={() => toggleAssignment(labeler.id, q.name)}
                    />
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
